import './styles.scss';

export const FilterButton = ({
  label,
  icon,
  onChangeFilter,
  isActive,
  id,
  type,
}) => {
  return (
    <button
      className={`filter-button ${isActive ? 'active' : ''}`}
      onClick={onChangeFilter}
      data-id={id}
      data-type={type}
    >
      <span>{label}</span>
      {icon}
    </button>
  );
};
